(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('StaysFormController', StaysFormController);


    StaysFormController.$inject = [
        '$stateParams',
        'stayService',
        'genericDataService',
		'$filter',
		'$rootScope',
		'$state',
        'notificationService', 
        '$scope'
    ];

    function StaysFormController($stateParams, stayService, genericDataService, 
        $filter, $rootScope, $state, notificationService, $scope) {

        /* PRIVATE VARIABLES */
        var id = $stateParams.id;


        /* PUBLIC VARIABLES */
		var vm = this;
		vm.edit = false;
		vm.stay = {};
		vm.stateParams = $stateParams;
        vm.genericData = {
            empresas: {
                list: null,
                selected: { id: null }
            },
            bases: {
                list: null,
                selected: { id: null }
            },
            colaboradores: {
                list: null,
                selectedEntrada: { id: null },
                selectedSalida: { id: null }
            },
            vehicleBrands: {
                list: null,
                selected: { id: null }
            },
            vehicleModels: {
                fullList: null,
                list: null,
                selected: { id: null }
            },
            vehicleColors: {
                list: null,
                selected: { id: null }
            },
            tiposVehiculo: {
                list: null,
                selected: { id: null }
            }
        };
        vm.dates = {
			entrada: Date.NewDate(),
            entradaPrev: null,
            salida: null,
            salidaPrev: null
		};

        /* PUBLIC FUNCTIONS */
        vm.onBrandChange = onBrandChange;
        vm.onModelChange = onModelChange;
        vm.save = save; 
		vm.saveAndClose = saveAndClose;
		vm.saveAndNew = saveAndNew;
		vm.effectClass = effectClass;
		vm.accionSaveList = [
			{
				accionTexto: 'Guardar y cerrar',
				accion: vm.saveAndClose,
				selected: computeValueAccionSelected('guardarCerrar')
			},
			{
				accionTexto: 'Guardar y nuevo',
				accion: vm.saveAndNew,
				selected: computeValueAccionSelected('saveAndNew')
			},
			{
				accionTexto: 'Guardar',
				accion: vm.save,
				selected: computeValueAccionSelected('save')
			},
		];

        /* INITIALIZER */
        (function () {
            getGenericData();

            //Edit
			if (id != null) {
				vm.edit = false;
                stayService.getStay(id)
                    .then(function (stay) {
                        vm.stay = stay;
                        setDates();
                        setCombosInitialData();
                    });
            }
            //New
        })();


        /* FUNCTION DEFINITIONS */
		function save() {
			var action = 'save';
			for (var i = 0; i < vm.accionSaveList.length; ++i) {
				if (vm.accionSaveList[i].accionTexto === 'Guardar') { vm.accionSaveList[i].selected = true; }
				else { vm.accionSaveList[i].selected = false; }
			}
			doSave(action);
		}

		function saveAndClose() {
			var action = 'saveAndClose';
			doSave(action);
		}

		function saveAndNew() {
			for (var i = 0; i < vm.accionSaveList.length; ++i) {
				if (vm.accionSaveList[i].accionTexto === 'Guardar y nuevo') { vm.accionSaveList[i].selected = true; }
				else { vm.accionSaveList[i].selected = false; }
			}
			var action = 'saveAndNew';
			doSave(action);
		}

        function sendErrorRequire() {
            notificationService.sendAppNotification({
                message: 'Las fecha de salida debe ser mayor o igual que la fecha de entrada',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'error'
            });
        }

        function doSave(action) {

            if (vm.stay.numdias < 0 || vm.stay.numdias == '-') {
                sendErrorRequire();
                return; 
            }
            vm.stay.empresaId = vm.genericData.empresas.selected.id;
			vm.stay.marcaId = vm.genericData.vehicleBrands.selected.id;
			vm.stay.marca = vm.genericData.vehicleBrands.selected.nombre;
			vm.stay.modeloId = vm.genericData.vehicleModels.selected.id;
			vm.stay.modelo = vm.genericData.vehicleModels.selected.nombre;
			vm.stay.color = vm.genericData.vehicleColors.selected.nombre;
			vm.stay.modelo = vm.genericData.vehicleModels.selected.nombre;
			vm.stay.tipovhcId = vm.genericData.tiposVehiculo.selected.id;
            vm.stay.baseId = vm.genericData.bases.selected.id;

			if (vm.stay.origsalida !== 0) {
				vm.stay.salidacolaboradorId = vm.genericData.colaboradores.selectedSalida.id;
			}
			if (vm.stay.origentrada !== 0) {
				vm.stay.entradacolaboradorId = vm.genericData.colaboradores.selectedEntrada.id;
			}

			vm.stay.fentrada = vm.dates.entrada;
			vm.stay.fentradaprev = vm.dates.entradaPrev;
			vm.stay.fsalida = vm.dates.salida;
			vm.stay.fsalidaprev = vm.dates.salidaPrev;

			stayService.addStay(vm.stay).then(function (staySave) {
				sendSAveNotification();
				vm.edit = true;
				if (action === 'saveAndClose') {
					$state.go('flota.estancias.listado');
				}
				else if (action === 'saveAndNew') {
					$state.go('flota.estancias.nuevo', { 'accion': 'saveAndNew' });
				}
				else {
					vm.stay.estanciaId = staySave.estanciaId;
				}
			});

		}

		function sendSAveNotification() {
			notificationService.sendAppNotification({
				message: 'La estancia se ha guardado correctamente',
				positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
			});
		}

        function onBrandChange() {
            var m = vm.genericData.vehicleBrands.selected && vm.genericData.vehicleBrands.selected.id;
            if(m){
                vm.genericData.vehicleModels.list = $filter('filter')
                    (vm.genericData.vehicleModels.fullList, {marcaId:m}, true);
                selectChanged(vm.genericData.vehicleModels.list, vm.genericData.vehicleModels.selected, false);
            }else{
                vm.genericData.vehicleModels.list = vm.genericData.vehicleModels.fullList;
                selectChanged(vm.genericData.vehicleModels.list, vm.genericData.vehicleModels.selected, false);
            }
        }

        function onModelChange() {
            var model  = findByProperty(vm.genericData.vehicleModels.list, 'id', 
                vm.genericData.vehicleModels.selected.id);
            if(model){
                var brand = findByProperty(vm.genericData.vehicleBrands.list, 'id', model.marcaId);
                vm.genericData.vehicleBrands.selected = brand;
            }
        }

        $scope.$watch('vm.dates.salida', function (o, n) {
     
            if (o == null) {
                vm.stay.numdias = '-';
            }
            else if (vm.dates.entrada == null) {
                vm.stay.numdias = '-';
            }
            else {
                var timeDiff = vm.dates.salida.getTime() - vm.dates.entrada.getTime();
                vm.stay.numdias = Math.ceil(timeDiff / (1000 * 3600 * 24));
            }

        }, true);

        $scope.$watch('vm.dates.entrada', function (o, n) {
        
            if (o == null) {
                vm.stay.numdias = '-';
            }
            else if (vm.dates.salida == null) {
                vm.stay.numdias = '-';
            }
            else {
                var timeDiff = vm.dates.salida.getTime() - vm.dates.entrada.getTime();
                vm.stay.numdias = Math.ceil(timeDiff / (1000 * 3600 * 24));
            }

        }, true);


        /* PRIVATE FUNCTIONS */
        function getGenericData() {
            vm.genericData.empresas.loading = true;
            genericDataService.getEmpresas()
                .then(function (res) {
                    vm.genericData.empresas.loading = false;
                    vm.genericData.empresas.list = res;
                    selectChanged(vm.genericData.empresas.list, vm.genericData.empresas.selected);

                    if (vm.genericData.empresas.selected.id == null) {
                        vm.genericData.empresas.selected = vm.genericData.empresas.list[0];
                    }
                });

            vm.genericData.colaboradores.loading = true;
            genericDataService.getColaboradores()
                .then(function (res) {
                    vm.genericData.colaboradores.loading = false;
                    vm.genericData.colaboradores.list = res;
                    selectChanged(vm.genericData.colaboradores.list, vm.genericData.colaboradores.selected);
                });

            vm.genericData.vehicleBrands.loading = true;
            genericDataService.getVehicleBrands()
                .then(function (res) {
                    vm.genericData.vehicleBrands.loading = false;
                    vm.genericData.vehicleBrands.list = res;
                    selectChanged(vm.genericData.vehicleBrands.list, vm.genericData.vehicleBrands.selected, false);
                });

            vm.genericData.vehicleModels.loading = true;
            genericDataService.getVehicleModel()
                    .then(function (res) {
                        vm.genericData.vehicleModels.loading = false;
                        vm.genericData.vehicleModels.fullList = res;
                        vm.genericData.vehicleModels.list = res;
                        selectChanged(vm.genericData.vehicleModels.list, vm.genericData.vehicleModels.selected, false);
                    });
            
            vm.genericData.vehicleColors.loading = true;
            genericDataService.getVehicleColors()
                .then(function (res) {
                    vm.genericData.vehicleColors.loading = false;
                    vm.genericData.vehicleColors.list = res;
                    selectChanged(vm.genericData.vehicleColors.list, vm.genericData.vehicleColors.selected, false);
                });

            vm.genericData.bases.loading = true;
            genericDataService.getBases()
                .then(function (res) {
                    vm.genericData.bases.loading = false;
                    vm.genericData.bases.list = res;
					selectChanged(vm.genericData.bases.list, vm.genericData.bases.selected);
					if (vm.genericData.bases.selected.id == null) {
						vm.genericData.bases.selected = vm.genericData.bases.list[0];
					}
                });

            vm.genericData.tiposVehiculo.loading = true;
            genericDataService.getTiposVhc()
                .then(function (res) {
                    vm.genericData.tiposVehiculo.loading = false;
                    vm.genericData.tiposVehiculo.list = res;
                    selectChanged(vm.genericData.tiposVehiculo.list, vm.genericData.tiposVehiculo.selected);
                });
        }

        //Valor inicial selects y combos
        function setCombosInitialData() {
            vm.genericData.empresas.selected = { nombre: null, id: vm.stay.empresaId };
            selectChanged(vm.genericData.empresas.list, vm.genericData.empresas.selected);
            
            vm.genericData.colaboradores.selectedEntrada = { nombre: null, id: vm.stay.entradacolaboradorId };
            selectChanged(vm.genericData.colaboradores.list, vm.genericData.colaboradores.selectedEntrada);
            vm.genericData.colaboradores.selectedSalida = { nombre: null, id: vm.stay.salidacolaboradorId };
            selectChanged(vm.genericData.colaboradores.list, vm.genericData.colaboradores.selectedSalida);
            
            vm.genericData.vehicleBrands.selected = { nombre: vm.stay.marca, id: vm.stay.marcaId };
            selectChanged(vm.genericData.vehicleBrands.list, vm.genericData.vehicleBrands.selected, false);
            vm.genericData.vehicleModels.selected = { nombre: vm.stay.modelo, id: vm.stay.modeloId };
            selectChanged(vm.genericData.vehicleModels.list, vm.genericData.vehicleModels.selected, false);
            vm.genericData.vehicleColors.selected = { nombre: vm.stay.color, id: null };
            selectChanged(vm.genericData.vehicleColors.list, vm.genericData.vehicleColors.selected, false);
            vm.genericData.tiposVehiculo.selected = { nombre: null, id: vm.stay.tipovhcId };
            selectChanged(vm.genericData.tiposVehiculo.list, vm.genericData.tiposVehiculo.selected);
            
            vm.genericData.bases.selected = { nombre: null, id: vm.stay.baseId };
            selectChanged(vm.genericData.bases.list, vm.genericData.bases.selected);
            
        }
        
        function setDates() {
            vm.dates.entrada = vm.stay.fentrada && new Date(vm.stay.fentrada);
            vm.dates.entradaPrev = vm.stay.fentradaprev && new Date(vm.stay.fentradaprev);
            vm.dates.salida = vm.stay.fsalida && new Date(vm.stay.fsalida);
            vm.dates.salidaPrev = vm.stay.fsalidaprev && new Date(vm.stay.fsalidaprev);
        }

        // Try to find the selected element in the list using the id property
        // If requireId is false it will keep the name even when id is null
        function selectChanged(list, selected, requireId) {
            requireId = (typeof requireId === 'undefined') ? true : requireId; //RequireId defaults to TRUE
            if (!list || !selected) { return; } //If the is no list or element exit
            if (list.length <= 0 || selected.id == null) { // Delete element unless it doesnt require id
                if (!requireId) { return; }
                selected.nombre = null;
                selected.id = null;
                return;
            }
            var find = findByProperty(list, 'id', selected.id);
            if (find) {
                selected.nombre = find.nombre;
                selected.id = find.id;
            } else {
                selected.nombre = null;
                selected.id = null;
            }
        }

        function findByProperty(array, property, id) {
            if(array===null){ return null; }
            for (var i = 0; i < array.length; i++) {
                if (array[i][property] === id) {
                    return array[i];
                }
            }
            return null;
		}

		function computeValueAccionSelected(accion) {
			if (accion === vm.stateParams.accion) { return true; }
			return false;
		}

		function effectClass(target) {
            vm.effects = {};
			vm.effects[target] = true;
			setTimeout(function () {
				vm.effects[target] = undefined;
			}, 3000);
		}

    }

})();

